import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProposalService } from '../../../shared/proposal.service';
import { SharedService } from '../../../shared/shared.service';
import { FormService } from '../../../shared/form.service';
import { OfferService } from '../../../shared/offer.service';
import { Observable, Subscription } from 'rxjs';
import { NdbxIcons } from '../../../../dependencies/qbe-components/src/lib/assets/fonts/ndbx-icon/ndbx-icons';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { PackagesTableComponent } from '../packages-table/packages-table.component';
import { debounceTime, distinctUntilChanged, map, pairwise } from "rxjs/operators";
import { InsuredSumModalComponent } from "../../../insured-sum-modal/insured-sum-modal.component";
import { TrackService } from 'src/app/services/track.service';
import * as shajs from 'sha.js';
import { MapTrackingService } from 'src/app/services/mapTracking.service';

interface Limit {
    min: number;
    max: number;
}

interface Limits {
    glass: Limit;
    GO: Limit;
}

interface IXOptions {
  stepIndex: number;
  progress: number;
  footerContent?: string;
  leftButtonsList?: [];
  rightButtonsList?: [];
  outlet?: any;
  backArrow?: any;
  formDisabled?: boolean;
  newCar: boolean;
}

const XDefaults: IXOptions = {
  stepIndex: 0,
  progress: 0,
  footerContent: '',
  leftButtonsList: [],
  rightButtonsList: [],
  backArrow: null,
  outlet: null,
  formDisabled: false,
  newCar: false
};

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})

export class OfferComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit {
  prevUrlSubs;

  packagesTableDialogRef: NxModalRef<PackagesTableComponent>;
  priceFormat: {
    'true': ['EUR', 'symbol', '3.2-2', 'es-US'],
    'false': ['лв.', 'symbol', '3.2-2', 'fr']
  };
  Icons = NdbxIcons;
  exchange: boolean = false;
  calculatedPremiums$;
  preloading = { title: 'proposal.title', image: 'woman-loading-page' };
  baseTable$;
  currentForm = this.formService.currentForm;
  isEarthQuakeIncluded: boolean;
  isGoMaxIncluded: boolean;
  isGlassIncluded: boolean;
  productProposal;
  changeSubs = new Subscription();
  selectedTabIndex = 0;
  componentRef: NxModalRef<any>;
  selectedPackageLast;
  installmentsNumber=1; 

  glassLimits = {
    EUR: { min: 255.65, max: 2556.46 },
    BGN: { min: 500, max: 5000 }
  }

  GOLimits = {
    EUR: { min: 2556.46, max: 7669.38 },
    BGN: { min: 5000, max: 15000 }
  }

  limits: Limits;

  constructor(
    public proposalService: ProposalService,
    public sharedService: SharedService,
    public offerService: OfferService,
    private chRef: ChangeDetectorRef,
    public formService: FormService,
    public router: Router,
    public dialogService: NxDialogService,
    public mapTrackingService: MapTrackingService,
    private route: ActivatedRoute,
    private trackService: TrackService) {
    this.isEarthQuakeIncluded = this.formService.currentForm.value.isEarthQuakeIncluded === 'T';
    this.isGoMaxIncluded = this.formService.currentForm.value.isGoMaxIncluded === 'T';
    this.isGlassIncluded = this.formService.currentForm.value.isGlassIncluded === 'T';
  }

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  messageChanged($event, control) {
    const val = $event ? 'T' : 'F';
    if (val === 'T') {
      this.sharedService.increaseLimitTicked = true;
      this.sharedService.savedGlassMin = this.currentForm.controls.glass.value;
      this.sharedService.savedMTPLMin = this.currentForm.controls.goLimit.value;
    } else if (val === 'F') {
      this.sharedService.increaseLimitTicked = false;
    }
    control.forEach(item => {
      this.formService.currentForm.get(item).setValue(val);
    })
    this.chRef.detectChanges();

  }

  tabChanged($event, paymentPlans?) {
    this.selectedTabIndex = $event.index;
    this.sharedService.selectedTabIndexForWhenUserGoesBackToPage = $event.index;
    if (paymentPlans) {
      this.selectPackage(paymentPlans[this.selectedTabIndex].packageId);
    }

    var span_Text = document.getElementById("span").innerHTML;
    var re = /&nbsp;/gi;
    var newstr = span_Text.replace(re, " ");
   // this.trackService.pushEventTracking('product.price', newstr)

  }

  selectedInstallments(value) {
    var span_Text = document.getElementById("span").innerHTML;
    var re = /&nbsp;/gi;
    var newstr = span_Text.replace(re, " ");
    this.installmentsNumber=value
    if(this.calculatedPremiums$){
      this.mapTrackingService.mapTrackPackages( this.formService.currentForm.controls.chosenPackageId.value, this.installmentsNumber, this.calculatedPremiums$)
    }

  }

  getNumberOfInstalments(proposals, item, index) {
    const sum = proposals[`bottom${ item }${ index }`];
    return sum;
  }

  getSelectedSum(proposals, item, val) {
    const instalments = {
      1: 'One',
      2: 'Two',
      4: 'Four',
    }
    const sum = proposals[`bottom${ item }${ instalments[val] }`];
    return sum;
  }

  getSelectedSumEuro(proposals, item, val) {
    const instalments = {
      1: 'One',
      2: 'Two',
      4: 'Four',
    }
    const sumEuro = proposals[`bottom${ item }${ instalments[val] }Curr2`];
    return sumEuro;
  }

  /*updateControl(snapshotData) {
    Object.assign(this.sharedService, XDefaults, snapshotData);
  }*/

  openPackageDetails(packagesTable, calculatedPremiums, selectedPackage) {
    this.trackService.pushEventTracking('navigationButton', 'Package details')
    this.packagesTableDialogRef = this.dialogService.open(PackagesTableComponent, {
      height: '100%',
      width: '100%',
      panelClass: 'packagesTableDialog',
      data: {
        packagesTable, calculatedPremiums, selectedPackage
      }, showCloseIcon: true
    });
  }

  selectPackage(selectedPackage) {
    this.formService.currentForm.controls.chosenPackageId.patchValue(selectedPackage);
    this.formService.currentForm.controls.selectedPackageId.patchValue(selectedPackage);
    this.formService.currentForm.updateValueAndValidity();

    if( this.calculatedPremiums$){
      this.mapTrackingService.mapTrackPackages(selectedPackage, this.installmentsNumber, this.calculatedPremiums$, "packages")
    }

    
  }

  getPrice(price, index) {
    if (this.selectedTabIndex !== index) {
      return `<span>${ price }</span>`;
    }
    return '';
  }

  ngAfterViewInit() {
  }

  ngOnInit(): void {
    this.baseTable$ = this.sharedService.baseTable$;
    let profileId = shajs('sha256').update(this.formService.currentForm.controls.firstCountryCode.value+ this.formService.currentForm.controls.firstPhoneNumber.value).digest('hex');
    this.trackService.pushEventTracking('user.profileId',profileId)
    /*if (this.proposalService.calculatedPremiums$) {
      this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
      this.calculatedPremiums$.subscribe(data => {
        this.selectedTabIndex = +data.chosenPackageId - 1;
      });
    }*/
    // window['qbhome'].push({
    //   process: {
    //     stenName: 'package-selection',
    //     stepNumber: '04',
    //     previousStepName: this.sharedService.previousStepName,
    //     previousStepNumber: this.sharedService.previousStepNumber
    //   }
    // });
    this.sharedService.previousStepNumber = '04';
    this.sharedService.previousStepName = 'package-selection';
    this.getLimits();
  }

  setDigitalDataConstructionYear(value) {
    let productNames = ['COMFORT', 'PLUS', 'MAX', 'EXTRA'];
    // if(value && (this.selectedPackageLast != value)) {
    //   window['qbhome'].push({
    //         'product': {
    //           'name': productNames[value-1]
    //     }
    //   });
    // }
    this.selectedPackageLast = value;
  }

  getRawData() {
    const keys = [
      "n_1NSP_Premium",
      "n_2NSP_Premium",
      "n_3NSP_Premium",
      "n_1NSP_PremiumCurr2",
      "n_2NSP_PremiumCurr2",
      "n_3NSP_PremiumCurr2",
      "purpose",
      "yearOfConstruction",
      "street",
      "claimsExists",
      "recommendedPackage",
      "discount1",
      "nErr_Code",
      "status",
      "contractProcessState",
      "currency",
      "doubleVisualization",
      "propertyCategory",
      "propertySubcategory",
      "postCode",
      "area",
      "insSumOutsideObjects",
      "insSumSpecificObjects",
      "isEarthQuakeIncluded",
      "isGlassIncluded",
      "isGoMaxIncluded",
      "isDeductibleIncluded",
      "isRenewed",
      "commissionDiscount",
      "immovableinsuranceSumRecommended",
      "movableinsuranceSumRecommended",
      "topComfort",
      "topExtra",
      "topMax",
      "bottomComfortOne",
      "bottomExtraOne",
      "bottomMaxOne",
      "bottomComfortTwo",
      "bottomExtraTwo",
      "bottomMaxTwo",
      "bottomComfortFour",
      "bottomExtraFour",
      "bottomMaxFour",
      "topComfortCurr2",
      "topExtraCurr2",
      "topMaxCurr2",
      "bottomComfortOneCurr2",
      "bottomExtraOneCurr2",
      "bottomMaxOneCurr2",
      "bottomComfortTwoCurr2",
      "bottomExtraTwoCurr2",
      "bottomMaxTwoCurr2",
      "bottomComfortFourCurr2",
      "bottomExtraFourCurr2",
      "bottomMaxFourCurr2",
      "glass",
      "goLimit",
      "selectedPayments",
      "selfParticipation",
      "doubleVisualization",
      'chosenPackageId']
    const data: any = {};
    const rawValue = this.formService.currentForm.getRawValue();
    keys.forEach(key => {
      data[key] = rawValue[key];
    });
    return data;
  }

  callback() {
    const data = this.getRawData();
    this.proposalService.calculatePremiums(data);
    this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
  }

  ngAfterContentInit() {
    this.route.data.subscribe((res: any) => {
      if (res?.proposals && !res.currentFormData) {
        const formData = this.formService.currentForm.getRawValue();
        // if(formData.immovableinsuranceSumRecommended || formData.movableinsuranceSumRecommended) {
        // res.proposals
        res.proposals.isDeductibleIncluded = formData.isDeductibleIncluded;
        res.proposals.isGlassIncluded = formData.isGlassIncluded;
        res.proposals.isGoMaxIncluded = formData.isGoMaxIncluded;
        res.proposals.isEarthQuakeIncluded = formData.isEarthQuakeIncluded;
        // }
        this.proposalService.calculatePremiums(res.proposals);
        this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
        if (res?.proposals?.recommendedPackage) {
          if (this.sharedService.selectedTabIndexForWhenUserGoesBackToPage === undefined) {
            this.selectedTabIndex = res.proposals.recommendedPackage - 1;
            this.selectPackage(res.proposals.recommendedPackage);
            this.trackService.pushEventTracking('product.paymentFrequency', 'Yearly')
          } else {
            this.selectedTabIndex = this.sharedService.selectedTabIndexForWhenUserGoesBackToPage;
            this.selectPackage(this.selectedTabIndex + 1);
            this.trackService.pushEventTracking('product.paymentFrequency', 'Yearly')
          }
        } 

      } else {
        if(this.sharedService.loadedFromCP == true || this.sharedService.isOfferFromEmail==true){
          this.callback();
          this.selectPackage(res.currentFormData.chosenPackageId);
          this.selectedTabIndex = +res.currentFormData.chosenPackageId-1;
        }
        else if (res.currentFormData) {
          this.formService.currentForm = this.formService.getMainForm();
          this.formService.currentForm.patchValue(res.currentFormData);
          this.formService.currentForm.controls.chosenPackageId.patchValue(res.currentFormData.chosenPackageId);
          res.proposals.isDeductibleIncluded = res.currentFormData.isDeductibleIncluded;
          res.proposals.isGlassIncluded = res.currentFormData.isGlassIncluded;
          res.proposals.isGoMaxIncluded = res.currentFormData.isGoMaxIncluded;
          res.proposals.isEarthQuakeIncluded = res.currentFormData.isEarthQuakeIncluded;
          this.formService.currentForm.controls.selectedPayments.value=this.installmentsNumber;
          this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
          this.selectPackage(res.currentFormData.chosenPackageId);
          this.selectedTabIndex = +res.currentFormData.chosenPackageId-1;
        
        // const data = this.getRawData();
        
          this.proposalService.calculatePremiums(res.productProposal);
          this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
          if(!res.currentFormData){
            this.calculatedPremiums$.subscribe(data => {
              this.selectPackage(data.chosenPackageId);
              this.selectedTabIndex = +data.chosenPackageId - 1;
            });
          }
        }
      }
    });
    let changeTimeout;
    ['isGoMaxIncluded', 'isEarthQuakeIncluded', 'isDeductibleIncluded', 'selectedPayments'].forEach(item => {
      this.formService.currentForm.controls[item].valueChanges.pipe(
        debounceTime(25),
        distinctUntilChanged(),
        pairwise()
      ).subscribe(([oldValue, value]) => {

        if (changeTimeout) {
          clearTimeout(changeTimeout)
        }
        const data = this.getRawData();
        this.selectedTabIndex = data.chosenPackageId - 1;
        if (oldValue !== value) {
          changeTimeout = setTimeout(() => {
            this.proposalService.calculatePremiums(data);
            this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
          }, 50);
        }
      });
    });

    if((this.sharedService.loadedFromCP == true || this.sharedService.isOfferFromEmail == true) && this.sharedService.isAlreadyLoadedOffer==false) {
      this.sharedService.isAlreadyLoadedOffer = true;
      this.router.navigate([this.sharedService._routeHistory[this.sharedService._routeHistory.length-1]])
    }
  }

  openDialog() {
    this.componentRef = this.dialogService.open(InsuredSumModalComponent, {
      data: {
        heading: 'insSumModal.heading',
        immovable: 'insSumModal.immovable',
        movable: 'insSumModal.movable',
        btnOkText: 'insSumModal.btnOkText',
        immovableLimit: 'insSumModal.immovableLimit',
        movableLimit: 'insSumModal.movableLimit'
      }, showCloseIcon: true
    });
    this.componentRef.afterClosed().subscribe(res => {
      this.callback();
    })
  }

  ngOnDestroy() {
    // this.changeSubs.unsubscribe();
    if (this.prevUrlSubs) {
      this.prevUrlSubs.unsubscribe();
    }
  }

  getLimits() : void {
    this.sharedService.getCurrency().subscribe((config) => {
        let currency = "EUR";
        if(config.main){
            currency = config.main;
        }
        this.limits = {
            glass: this.glassLimits[currency],
            GO: this.GOLimits[currency]
        }
    });
  }
}
